import { createMuiTheme, responsiveFontSizes } from "@material-ui/core/styles";

const CustomTheme = createMuiTheme({});

export default responsiveFontSizes(CustomTheme);
